import { useContext } from 'react';
import { RolesAndPermissionsContext } from 'context/RolesAndPermissionsContext';

export const useCanUser = (permissionType, customList) => {
    const rolesAndPermissions = useContext(RolesAndPermissionsContext);

    return rolesAndPermissions?.canUser(permissionType, customList);
};
